// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionNotIsEqualToFragmentDoc = `
    fragment questionnaireConditionNotIsEqualTo on QuestionnaireConditionNotIsEqualTo {
  __typename
  question {
    id
  }
  valueString: value
}
    `;